import { requestAnalytics } from '@/services/bridge'

export const eventTag1 = () => {
  requestAnalytics('PRIMEIRO_DEPOSITO_ACESSO', {
    screen: 'Primeiro depósito',
    content_action: 'Dados carregados',
    product: 'missao da conta',
  })
}
export const eventTag2 = (keyType: PixType) => {
  requestAnalytics('PRIMEIRO_DEPOSITO_FLUXO', {
    content_action: 'toque',
    action_id: 'copiar chave',
    content_id: keyType,
    screen: 'Primeiro depósito',
    product: 'missao da conta',
  })
}
export const eventTag3 = (keyType: PixType) => {
  requestAnalytics('PRIMEIRO_DEPOSITO_FLUXO', {
    content_action: 'toque',
    action_id: 'copiar chave cta',
    content_id: keyType,
    screen: 'Primeiro depósito',
    product: 'missao da conta',
  })
}
export const eventTag4 = () => {
  requestAnalytics('PRIMEIRO_DEPOSITO_FLUXO', {
    content_action: 'toque',
    action_id: 'usar outra chave',
    screen: 'Primeiro depósito',
    product: 'missao da conta',
  })
}

export const eventTag5 = () => {
  requestAnalytics('PRIMEIRO_DEPOSITO_ACESSO', {
    screen: 'Primeiro depósito',
    content_action: 'Erro ao carregar dados',
    product: 'missao da conta',
  })
}
